/**
 * Created by Carsten Bühler
 * User: c.buehler on 23.04.2019
 * Copyright: xdot GmbH 2019
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { Icon } from 'plugin/base-portlet';

import StateValueLabel from './StateValueLabel';

const FliwasStatusIcon = props => {
    return (
        <div className="object-icon">
                <Icon name={props.iconClassName}/>
            {props.stateValue && <StateValueLabel item={props.stateValue} showText={false}/>}
        </div>
    );
};
FliwasStatusIcon.propTypes = {
    iconClassName: PropTypes.string.isRequired,
    stateValue: PropTypes.object.isRequired
};

export default FliwasStatusIcon;



// WEBPACK FOOTER //
// ./js/components/FliwasStatusIcon.jsx